// noinspection JSNonASCIINames,NonAsciiCharacters

export const employeeTranslations = {
    new_employee: {
        header: "Teade uue töötaja kohta",
        personal_info: {
            header: "Töötaja andmed",
            lives_in_estonia: "Kas töötaja täidab oma tööülesandeid Eesti territooriumil elades?",
            name: "Eesnimi",
            surname: "Perekonnanimi",
            full_name: "Töötaja täisnimi",
            personal_code: "Isikukood",
            residential_address: "Töötaja elukoha aadress",
            citizenship_question: "Kas töötajal on <1>Eesti</1>, <3>EL/EMP</3> riikide või Šveitsi kodakondsus?",
            citizenship_question_tip: "<0>EL-i riigid</0>Austria, Belgia, Bulgaaria, Tšehhi, Taani, Prantsusmaa, Prantsuse Guajaana, Kreeka, Guadeloupe, Horvaatia, Eesti, Island, Itaalia, Iirimaa, Küpros, Leedu, Liechtenstein, Luksemburg, Malta, Martinique, Holland, Norra, Poola, Portugal, Réunion, Rumeenia, Slovakkia, Sloveenia, Soome, Hispaania, Ungari, Saksamaa, Rootsi." +
                "<br/><br/>" +
                "<3>EMP riigid</3> Euroopa Liidu riigid + Island, Liechtenstein, Norra",
            clear_data: "Kustuta kõik varem sisestatud andmed",
            has_right_to_work: "Kas töötajal on õigus Eestis töötada?",
            right_to_work_perm_permit: "Jah, alalise elamisloa alusel",
            right_to_work_temp_permit: "Jah, ajutise elamisloa alusel",
            right_to_work_short_term_permit: "Jah, lühiajalise tööloa alusel",
            right_to_work_unknown: "Ei tea",
            ask_employee_status: "Kui te ei tea, kas töötajal on õigus Eestis töötada, peate selle töötajalt täpsustama",
            employee_should_know_status: "Töötaja peab teadma vastust sellele küsimusele!",
            cant_hire: "Kui välismaalane töötaja ei tea oma tööõiguslikku staatust, ei saa te teda tööle võtta.",
            allowed_to_work_based_on: "Võib töötada alusel",
            allowed_to_work_based_on_type: {
                citizenship: "EL/EMP riikide kodakondsus",
                short_term: "Lühiajalise tööloa alusel",
                temp_permit: "Ajutise elamisloa alusel",
                perm_permit: "Alalise elamisloa alusel",
                not_allowed: "Ei oma õigust töötada Eestis!",
            },
        },
        contract_details: {
            header: "Lepinguandmed",
            contract_type: "Lepingu tüüb",
            contract_employment: "Töötaja",
            contract_board: "Juhatuse liige",
            impossible_to_register: "Väljaspool Eestit elavat töötajat ei ole võimalik Eesti Töötukassa registris registreerida",
            position: "Ametinimetus",
            work_address: "Töökoha aadress",
            work_address_tip: "Palun täpsustage aadress, kus töötaja viibib töö täitmisel.<br/>" +
                "ЕKui töötaja töötab kaugtööna, siis märkige tema isiklik aadress.<br/>" +
                "Kui töötaja on autojuht või meremees, märkige oma juriidiline aadress.",
            rate_type: "Tasustamise tüüp",
            hourly_rate: "Tunnitasu",
            monthly_rate: "Kuutasu",
            salary: "Bruto palga määr",
            salary_tip: "Töölepingu seaduse kohaselt ei saa lepingus märkida netosumma tasu.<br/>" +
                "<2>Teil tuleb märkida brutotasu summa</2><br/> " +
                "Te saate kasutada <5>palga kalkulaatorit</5> lepingu brutosumma arvutamiseks<br/>" +
                "<2>2022. aasta minimaalne bruto töötasu on 654 eurot kuus või 3,86 eurot tunnis.</2>",
            rate_per_month: "eurot kuus",
            rate_per_hour: "eurot tunnis",
            works_full_time: "Kas töötaja töötab täiskohaga?",
            time_allocation: "Töökoormus",
            full_time_allocation: "Täistööaeg",
            part_time_allocation: "Osaline tööaeg",
            works_full_time_tip: "Kui töötaja töötab täiskohaga, peate valima<1>Jah</1><br/>" +
                "Osalise tööajaga - number 1 tähendab, et töötaja töötab täistööajaga ja 0,5 - pool päeva",
            start_date: "Lepingu alguskuupäev *",
            has_end_date: "Kas lepingul on lõppkuupäev?",
            end_date: "Lõppkuupäev  *",
            probation_period: "Kas lepingul on prooviperiood?",
            probation_period_len: "Prooviaja pikkus (kuudes)",
            probation_period_len_tip: "Töölepingu seaduse kohaselt ei tohi prooviaeg olla pikem kui 4 kuud",
        },
        tax_and_templates: {
            header: "Maksustamine",
            tax_residence: "Maksukohuslase riik",
            tax_residence_est: "Eesti",
            tax_residence_other: "Teine riik",
            tax_residence_country: "Riik",
            tax_residence_country_placeholder: "Maksukohuslase riik",
            tax_residence_unknown: "Teadmata",
            ask_tax_residence: "Töötaja peab esitama tõendi maksuresidentsuse kohta maksuametist",
            tax_deduction: "Kas töötajale on vaja tulumaksuvaba miinimumi avaldust?",
            tax_deduction_info_note: "Pange tähele, et maksusoodustust ei saa kasutada, kui töötaja kuusissetulek on suurem kui 1200 eurot brutos",
            tax_deduction_template: "Tulumaksuvaba miinimumi avalduse malli saate alla laadida",
            should_we_register_employee: "Kas soovite, et registreeriksime uue töötaja tööregistris?",
            should_we_register_employee_tip: "Kui valite <1>Jah</1> - siis meie raamatupidaja registreerib uue töötaja tööregistris.<br/>" +
                "Teil ei ole vaja selle pärast muretseda.",
            need_contract_template: "Kas vajate lepingu näidist?",
            countersigning_person_name: "Lepingule allkirja andva isiku täisnimi",
            countersigning_person_name_tip: "Tavaliselt kirjutab allkirja kas organisatsiooni juht (tegevdirektor) või mõni muu volitatud isik (personaliosakonna juhataja).",
            day_of_payment: "Palgapäev (1. ja 28. kuupäeva vahel)",
            day_of_payment_tip: "Selleks kuupäevaks peab tööandja saatma maksekorralduse pangale töötaja palga ülekandmiseks",
            iban: "Töötaja IBAN",
            duties_description: "Töötaja ülesannete lühikirjeldus",
            check_before_signing: "Laadige lepingu mall alla, kontrollige ja allkirjastage see",
            correctness_wavier: "Palun pange tähele, et me ei vastuta lepingu korrektse koostamise eest. See mall on koostatud meie töötajate lepingute alusel.",
            only_for_help_wavier: "Mall, mille kavatsete alla laadida, on loodud abivahendina, kõik juriidilised riskid võtate enda peale",
            download_here: "Malli saate alla laadida, klõpsates",
        },
        document_upload: {
            header: "Dokumentide üleslaadimine",
            document: "Töötaja dokument (pass või ID-kaart)",
            work_permit: "Töötamise õigust tõendav dokument (elamisluba või D-viisa)",
            tax_residence: "Maksuresidentsuse tõend",
            tax_deduction: "Töötaja allkirjastatud avaldus maksusoodustuse kohta",
            work_contract: "Allkirjastatud tööleping",
        },
        review: {
            header: "Ülevaade",
            start_date: "Lepingu alguskuupäev",
            end_date: "Lepingu lõppkuupäev",
            perm_contract: "Puudub (tähtajatu leping)",
            probation_period: "Prooviaeg",
            no_probation_period: "Ilma prooviajata",
            probation_period_len_one: "{{count}} kuu",
            probation_period_len_other: "{{count}} kuud",
            should_we_register_worker: "Kas raamatupidaja peaks registreerima töötaja tööregistris?",
        },
        upload: {
            header: "Üleslaadimine"
        },
    }
}